import React from 'react';
import { UrgencyBar } from './UrgencyBar';
export function CTAFinal() {
  return <>
      <UrgencyBar data-id="element-48" />
      <section className="bg-hero-gradient text-center py-[60px] px-5 border-t border-gold" data-id="element-49">
        <div className="max-w-[760px] mx-auto" data-id="element-50">
          <p className="text-xl md:text-[32px] font-black text-white mb-3" data-id="element-51">
            Tu fe merece una <span className="text-gold" data-id="element-52">presencia real</span>{' '}
            en el mundo digital
          </p>
          <p className="text-[15px] text-text-muted mb-8" data-id="element-53">
            Empezá hoy. Acceso inmediato. Garantía 7 días.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-6" data-id="element-54">
            <a href="https://www.stockdigital.shop/checkouts/cn/hWNC0JGtZ4UXGzFFtqS60pr0/es-ar?_r=AQABgqRKz8X0FzFMzgg2iw3bFO43mKzRGrYWJsB1MM2QPv4&cart_link_id=vPJR0qhR&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" className="bg-transparent border-2 border-gold text-gold font-black py-4 px-7 text-[14px] rounded-full no-underline transition-transform duration-200 hover:scale-[1.03]" data-id="element-55">
              📘 ESENCIAL — $19.000 ARS
            </a>
            <a href="https://www.stockdigital.shop/checkouts/cn/hWNC0JjlP8Cgi0TOiEBMJahW/es-ar?_r=AQABl53XfnJuUoQlYTYA1OzFYJvH1lnvoCApAL-3pOqOIT0&cart_link_id=QH8Ec45e&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" className="bg-gold-gradient text-base font-black py-4 px-7 text-[14px] rounded-full no-underline transition-transform duration-200 hover:scale-[1.03]" data-id="element-56">
              🏆 COMPLETO — $27.000 ARS
            </a>
          </div>

          <div className="text-[13px] text-[#666] mt-4 flex justify-center flex-wrap gap-4" data-id="element-57">
            <span data-id="element-58">🔒 Pago 100% seguro</span>
            <span data-id="element-59">⚡ Acceso en 5 minutos</span>
            <span data-id="element-60">🛡️ Garantía 7 días</span>
          </div>

          <p className="text-xs text-[#555] mt-3" data-id="element-61">
            Mercado Pago · Tarjeta · Transferencia
          </p>
        </div>
      </section>
    </>;
}